/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiIncrementalityControlGroupTypeFromJSON, ApiIncrementalityControlGroupTypeToJSON, } from './ApiIncrementalityControlGroupType';
import { ApiIncrementalityControlRegionPayloadFromJSON, ApiIncrementalityControlRegionPayloadToJSON, } from './ApiIncrementalityControlRegionPayload';
import { ApiIncrementalityTestStatusFromJSON, ApiIncrementalityTestStatusToJSON, } from './ApiIncrementalityTestStatus';
import { ApiIncrementalityTestTypeFromJSON, ApiIncrementalityTestTypeToJSON, } from './ApiIncrementalityTestType';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
export function ApiIncrementalityTestPayloadFromJSON(json) {
    return ApiIncrementalityTestPayloadFromJSONTyped(json, false);
}
export function ApiIncrementalityTestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'baselineGeneratedAt': !exists(json, 'baselineGeneratedAt') ? undefined : (new Date(json['baselineGeneratedAt'])),
        'controlGroupType': !exists(json, 'controlGroupType') ? undefined : ApiIncrementalityControlGroupTypeFromJSON(json['controlGroupType']),
        'controlRegions': !exists(json, 'controlRegions') ? undefined : (json['controlRegions'].map(ApiIncrementalityControlRegionPayloadFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'preTestFrom': !exists(json, 'preTestFrom') ? undefined : (new Date(json['preTestFrom'])),
        'preTestTo': !exists(json, 'preTestTo') ? undefined : (new Date(json['preTestTo'])),
        'primaryMetric': !exists(json, 'primaryMetric') ? undefined : ApiMetricFromJSON(json['primaryMetric']),
        'status': !exists(json, 'status') ? undefined : ApiIncrementalityTestStatusFromJSON(json['status']),
        'supportingMetrics': !exists(json, 'supportingMetrics') ? undefined : (json['supportingMetrics'].map(ApiMetricFromJSON)),
        'testFrom': !exists(json, 'testFrom') ? undefined : (new Date(json['testFrom'])),
        'testRegionCity': !exists(json, 'testRegionCity') ? undefined : json['testRegionCity'],
        'testRegionCountry': !exists(json, 'testRegionCountry') ? undefined : json['testRegionCountry'],
        'testRegionLat': !exists(json, 'testRegionLat') ? undefined : json['testRegionLat'],
        'testRegionLon': !exists(json, 'testRegionLon') ? undefined : json['testRegionLon'],
        'testTo': !exists(json, 'testTo') ? undefined : (new Date(json['testTo'])),
        'type': !exists(json, 'type') ? undefined : ApiIncrementalityTestTypeFromJSON(json['type']),
    };
}
export function ApiIncrementalityTestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'baselineGeneratedAt': value.baselineGeneratedAt === undefined ? undefined : (value.baselineGeneratedAt.toISOString()),
        'controlGroupType': ApiIncrementalityControlGroupTypeToJSON(value.controlGroupType),
        'controlRegions': value.controlRegions === undefined ? undefined : (value.controlRegions.map(ApiIncrementalityControlRegionPayloadToJSON)),
        'name': value.name,
        'preTestFrom': value.preTestFrom === undefined ? undefined : (value.preTestFrom.toISOString()),
        'preTestTo': value.preTestTo === undefined ? undefined : (value.preTestTo.toISOString()),
        'primaryMetric': ApiMetricToJSON(value.primaryMetric),
        'status': ApiIncrementalityTestStatusToJSON(value.status),
        'supportingMetrics': value.supportingMetrics === undefined ? undefined : (value.supportingMetrics.map(ApiMetricToJSON)),
        'testFrom': value.testFrom === undefined ? undefined : (value.testFrom.toISOString()),
        'testRegionCity': value.testRegionCity,
        'testRegionCountry': value.testRegionCountry,
        'testRegionLat': value.testRegionLat,
        'testRegionLon': value.testRegionLon,
        'testTo': value.testTo === undefined ? undefined : (value.testTo.toISOString()),
        'type': ApiIncrementalityTestTypeToJSON(value.type),
    };
}
